<script>
import data from '~/components/_archive/o-carousel-v1.data'
import OCarouselV2 from '~/components/organisms/o-carousel/o-carousel-v2'

export default {
  mixins: [OCarouselV2],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-carousel-v1',
    }
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-carousel-v1 {
  position: relative;
  min-height: 667px;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);

  ::v-deep a,
  ::v-deep .a-cta,
  ::v-deep button {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep .slick-slider {
    display: grid;
    // Css grid defect with min-width 0 and 1fr. Set to min of 361px.
    grid-template-columns: minmax(361px, 1fr);
  }
  ::v-deep .slick-track {
    min-width: 0;
  }
  ::v-deep .m-carousel-nav button {
    pointer-events: auto;
  }

  .grid {
    position: relative;
    display: block;
    vertical-align: middle;
  }

  &__nav {
    @include container();

    display: flex;
    justify-content: flex-start;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    bottom: 60px;
    width: 100%;
    z-index: 1;
  }

  &__pattern {
    display: none;
  }

  ::v-deep .m-slide-v2__caption {
    top: 0;
  }
}

@include media-breakpoint-up(sm) {
  .o-carousel-v1 {
    &__nav {
      justify-content: flex-end;
      transform: none;
      top: 100px;
      bottom: initial;
    }
  }
}

@include media-breakpoint-up(lg) {
  .o-carousel-v1 {
    min-height: 833px;
  }
}
</style>
